import {
    andThen,
    Decoder,
    fail,
    field,
    map,
    oneOf,
    string,
    succeed
} from 'json-bouncer'
import {
    IntermediateSession,
    intermediateSessionDecoder
} from '../Data/IntermediateSession'

export type M = LoginSuccess | EmailNotFound | PasswordWrong

export interface LoginSuccess {
    readonly type: 'LoginSuccess'
    readonly intermediateSession: IntermediateSession
}

export interface EmailNotFound {
    readonly type: 'EmailNotFound'
}

export interface PasswordWrong {
    readonly type: 'PasswordWrong'
}

export function decoder(): Decoder<M> {
    return (
        oneOf([
            map(
                (intermediateSession): M =>
                    ({type: 'LoginSuccess', intermediateSession}),
                intermediateSessionDecoder(),
            ),
            andThen(
                (error: string): Decoder<M> => {
                    switch (error) {
                        case 'EmailNotFound':
                            return succeed<M>({type: 'EmailNotFound'})
                        case 'PasswordWrong':
                            return succeed<M>({type: 'PasswordWrong'})
                        default:
                            return fail(`Unexpected error message: ${error}`)
                    }
                },
                field('error', string())),
        ]))
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/LoginResponse.ts